import React, { useState } from 'react';
import { type Control, useForm } from 'react-hook-form';

import Button from '@components/uikit/Button/Button';
import Checkbox from '@components/uikit/Checkbox/Checkbox';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import ModalHeader from '../ModalHeader/ModalHeader';
import { SENSOR_REPLACE_FIELDS } from '../SensorReplaceModal/constants/schemaSensorReplace';
import style from './style.module.scss';

interface IProps {
  onForceSubmit: () => void;
  control: Control;
}

const ReplaceC1D1SensorConfirmModal = ({ onForceSubmit, control }: IProps) => {
  const { t } = useTranslation();
  const { setSecondaryModalClose } = useModalActions();

  return (
    <div className={style.replaceConfModal}>
      <ModalHeader />
      <div className={style.modalBody}>
        <h1 className={style.modalTitle}>{t('Warning')}</h1>
        <div className={style.modalContent}>
          <div className={style.modalDescr}>
            <p>
              {t(
                'You are attempting to install a sensor that is not certified for use in a hazardous environment.',
              )}
            </p>
            <p>
              {t('Using an incorrect sensor type in this location creates a serious fire or explosion hazard.')}
            </p>
            <p
              dangerouslySetInnerHTML={{
                __html: t('Please contact {supportLink} before continuing.', {
                  supportLink: `<a href="mailto:support@waites.net" class=${style.link}>support@waites.net</a>`,
                }),
              }}
            />
          </div>
          <Checkbox
            label={t('I understand the risk. Continue with the replacement.')}
            control={control}
            name={SENSOR_REPLACE_FIELDS.CONFIRM_C1D1_REPLACE}
            required
          />
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button
          onClick={() => {
            onForceSubmit();
          }}
          type="primary"
          text={t('Confirm')}
        />
        <Button onClick={() => setSecondaryModalClose()} type="secondary" text={t('Cancel')} />
      </div>
    </div>
  );
};

export default ReplaceC1D1SensorConfirmModal;
